module.exports = __webpack_public_path__ + "img/card_icon_v1_discover.588f7b4e.svg";